"use strict";
/**
 * Routing Engine API Types
 * Shared contract between dev-processes and aerotage_routing_engine Lambda
 *
 * Copyright (c) 2024 Aerotage Design Group Inc. All rights reserved.
 * PROPRIETARY AND CONFIDENTIAL
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ROUTING_OPTIONS = void 0;
exports.mapDeviceType = mapDeviceType;
exports.mapPriority = mapPriority;
/**
 * Default routing options
 */
exports.DEFAULT_ROUTING_OPTIONS = {
    iterations: 0, // 0 = auto-calculate from quality
    quality: 2, // balanced
    min_horizontal_segment_mm: 25,
    min_vertical_segment_mm: 10,
};
/**
 * Map frontend device types to router device types
 */
function mapDeviceType(type) {
    const mapping = {
        connector: 'connector',
        terminal_block: 'terminal_block',
        junction: 'junction',
        module: 'module',
        switch: 'switch',
        ground_bus: 'ground_bus',
        splice: 'splice',
    };
    return mapping[type.toLowerCase()] || 'generic';
}
/**
 * Map frontend priority to router priority
 */
function mapPriority(priority) {
    if (!priority)
        return 'branch';
    const mapping = {
        trunk: 'trunk',
        branch: 'branch',
        local: 'local',
        high: 'trunk',
        normal: 'branch',
        low: 'local',
    };
    return mapping[priority.toLowerCase()] || 'branch';
}
//# sourceMappingURL=routing-api.js.map